import { MainHelper } from '@global/infrastructure/helpers/main-helper';
MainHelper.setup();
